import { render, staticRenderFns } from "./TeacherServiceTagEdit.vue?vue&type=template&id=5a23dae0&scoped=true"
import script from "./TeacherServiceTagEdit.vue?vue&type=script&lang=js"
export * from "./TeacherServiceTagEdit.vue?vue&type=script&lang=js"
import style0 from "./TeacherServiceTagEdit.vue?vue&type=style&index=0&id=5a23dae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23dae0",
  null
  
)

export default component.exports